import {fromJson} from '../../core/data-source/json.mapper';
import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';
import {httpService} from '../../core/services/http.service';
import {CustomerLocationRecord} from '../../records/customer-location.record';

export class LocationCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/cl';

    search(query: string): Promise<T[]> {
        let queryString: string =
            '?query=' +
            encodeURIComponent(query || '') +
            '&types=landmarks' +
            '&types=geocoding' +
            '&calculateNearestPoint=false' +
            '&limit=25' +
            '&strictSearch=false';
        return httpService.get(this.apiPath + '/listByPickup' + queryString).then((response: any) => {
            return response.data.rows.slice(0, 25).map((v: any) => fromJson(this.recordClass, v));
        });
    }

    getCustomerLocation(id: number, date: number): Promise<CustomerLocationRecord> {
        return httpService
            .get('/gt/gt-api/gtcl/' + id + '/' + date)
            .then((response: any) => fromJson(CustomerLocationRecord, response.data.rows.pop()));
    }
}
